<template>
    <div id="app">
        <div v-show="loading" class="loading">
            <i class="fas fa-sync-alt fa-spin fa-5x"></i>
        </div>
        <div v-show="!loading">
        <header class="header u-mb1" v-if="authenticated">
        <div class="row u-p1 u-full-width">
            <div class="col-sm">
                <a href="#" @click="home">
                    <img class="u-pl2" src="https://shift-manager.mobilerocket.co.uk/storage/business-logos/rocket.png" style="height:50px;"/>
                </a>
            </div>
            <div class="col-sm">

                <a class="btn btn-danger float-right text-light u-ml1" href="#/" v-on:click="$root.logout()" v-if="authenticated">
                    <i class="fas fa-sign-out-alt"></i>
                    Logout
                </a>

                <a class="btn btn-primary float-right text-light u-ml1" href="#/builder" v-if="!read_only">
                    <i class="fas fa-plus-square"></i>
                    Create New Form
                </a>
                <a class="btn btn-secondary float-right text-light u-ml1" href="#/" v-on:click="$root.clearUserId()" v-if="$root.user_type === 'rocket'">
                    <i class="fas fa-rocket"></i>
                    Home
                </a>
                <!--<a class="btn btn-primary float-right text-light u-mr1" href="#/payment/add">
                    <i class="fas fa-plus-square"></i>
                    Add ID Check Credits
                </a>-->
            </div>
        </div>


        </header>

            <router-view/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app',
    data : function () {
        return {

        };
    },
    components: {
        //
    },
    computed : {
        loading : function () {
            return this.$root.loading
        }
    },
    methods:{
        home()
        {
            this.$router.push({name : 'index'});
        }
    },
}
</script>

<style lang="scss">
@import "./sass/app.scss";
#app {
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
}
.header {
    display: flex;
    background: #fff;
    box-shadow: 0px 0px 5px 0px #3a3a3a;
}
</style>
